'use strict';

require('../../picker/style/css');